'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _FavoritesBar = require('./FavoritesBar');

var _FavoritesBar2 = _interopRequireDefault(_FavoritesBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _FavoritesBar2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/FavoritesBar/index.js
// module id = 577
// module chunks = 11